import type { SelectProps } from 'antd';
import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from '../col';
import { Fieldset } from '../fieldset';
import { Row } from '../row';
import { Select as DefaultSelect } from '../select';
import {
  useBirthDateChange,
  useDayOptions,
  useIncludesFilter,
  useMonthOptions,
  useStartsWithFilter,
  useYearOptions,
} from './hooks';

export type BirthDatePickerSelectOption = { label: string; value: number };

export type BirthDateType = {
  date: Date;
  day: number;
  isNumberOfDaysValid?: boolean;
  month: number;
  year: number;
};

type BirthDatePickerProperties = {
  id?: string;
  onChange?: (value: Partial<BirthDateType>) => void;
  Select?: ComponentType<SelectProps<number, BirthDatePickerSelectOption>>;
  value?: BirthDateType;
};

// TODO: Fix layout of this component is broken
const BirthDatePicker = ({ id, onChange, Select = DefaultSelect, value }: BirthDatePickerProperties) => {
  const { t } = useTranslation(['translationReactComponents']);

  const monthOptions = useMonthOptions();
  const dayOptions = useDayOptions(value);
  const yearOptions = useYearOptions();
  const onChangeDate = useBirthDateChange(value, onChange);

  const filterByIncludes = useIncludesFilter();
  const filterByStartsWith = useStartsWithFilter();

  return (
    <Fieldset legend={{ title: t('Birth date') }}>
      <Row gutter={['xs', 'xs']}>
        <Col span={12}>
          <Select
            allowClear
            id={id}
            onChange={(selectedValue) => onChangeDate({ month: selectedValue })}
            options={monthOptions}
            // TODO remove placeholder after every input has its own label in #59310
            placeholder={t('Month')}
            showSearch={{
              filterOption: filterByIncludes,
            }}
            value={value?.month}
          />
        </Col>
        <Col span={6}>
          <Select
            allowClear
            onChange={(selectedValue) => onChangeDate({ day: selectedValue })}
            options={dayOptions}
            // TODO remove placeholder after every input has its own label in #59310
            placeholder="DD"
            showSearch={{
              filterOption: filterByStartsWith,
            }}
            value={value?.day}
          />
        </Col>
        <Col span={6}>
          <Select
            allowClear
            onChange={(selectedValue) => onChangeDate({ year: selectedValue })}
            options={yearOptions}
            // TODO remove placeholder after every input has its own label in #59310
            placeholder="YYYY"
            showSearch={{
              filterOption: filterByStartsWith,
            }}
            value={value?.year}
          />
        </Col>
      </Row>
    </Fieldset>
  );
};

export default BirthDatePicker;
